<template>
  <div id="app">
    <layout-default>
      <div v-if="_isDesktop && $route.query.type === 'live'" class="live-logo">
        <img :src="`${publicPath}assets/images/TREBEL-logo.svg`" alt="" />
        <span class="presenta-label">PRESENTA</span>
      </div>
      <router-view />
    </layout-default>
  </div>
</template>

<script>
export default {
  computed: {
    backgroundClass() {
      return this._isDesktop && this.$route.query.type === "live"
        ? "body-bg-live-web"
        : this.$route.query.type === "walmart"
        ? "body-bg-auth-walmart"
        : "body-bg-auth";
    }
  },
  mounted() {
    document.body.classList.add(this.backgroundClass);
  },
  destroyed() {
    document.body.classList.remove(this.backgroundClass);
  }
};
</script>
<style scoped>
@import "assets/css/deleteAccountStyle.css";
@import "assets/css/baseStyle.css";
</style>
